import React from 'react';

const VehicleFeatures = ({ features }) => {
    console.log("Vehicle Features: ", features);
    if (features == null || Object.keys(features).length === 0) {
        return <div className="vehicle-features"><h4>No Features Available</h4></div>;
    }

    return (
        <div className="vehicle-features">
            <h2>Vehicle Features</h2>
            <ul>
                {Object.entries(features).map(([featKey, i]) => (
                    <><h3>{featKey.replace(/_/g, " ")}: </h3><span key={i}>{features[featKey] ? '✅ Enabled' : '❌ Disabled'}</span><br/></>
                ))}
            </ul>

        </div>
    );
};

export default VehicleFeatures;
